import React, { useState, useContext, useMemo, useEffect, useCallback, } from "react";
import debounce from "lodash/debounce";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { FormControlLabel, ListItem, FormControl } from "@mui/material";
import _ from "lodash";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import UserService from "services/UserService";
import axios from "axios";
import { getBillsQuery } from "services/ConfigServices";
import { energyData, sources, consoUnitData, displaymethodData, displayBillsColumnsData, billcanceled } from "variables/lists/bills";
import { billtext, billpagetext } from "variables/bills";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button";
import { AddCircleOutline } from "@mui/icons-material";
import moment from "moment";
import advancedSearchStyle from "assets/jss/material-dashboard-pro-react/components/advancedSearchStyle";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { makeStyles } from "@mui/styles";
import uuid from "react-uuid";
import LineFilter from "./LineFilter";
import RefreshIcon from '@mui/icons-material/Refresh';
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";
import CustomSelect from "components/Input/CustomSelect.js";
import { Menu, MenuItem } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { downloadCSV } from "components/ExportTableToCSV/ExportTableToCSV";
import GetAppIcon from '@mui/icons-material/GetApp';
import Dialog from "@mui/material/Dialog";
import MuiDialogContent from "@mui/material/DialogContent";
import { withStyles } from "@mui/styles";
import LinearProgress from '@mui/material/LinearProgress';

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
  color: grey;
`;

const TableName = styled.h1`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

const FilterDiv = styled.div`
  margin-right: auto;
  margin-top: 1px;
`;

const LoadingText = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);


const useStyles = makeStyles(styles);

export default function useBillsTable() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;

  const [openMenu, setOpenMenu] = React.useState(null);
  const [totalRows, setTotalRows] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState([]);

  const [openloading, setOpenloading] = useState(null);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [sorted, setSorted] = useState();
  const [dbValue, setDbValue] = useState("");


  const [energychoice, setEnergychoice] = useState("choice");
  const [selectedBills, setSelectedBills] = useState([]);

  const [displaymethod, setDisplaymethod] = useState("docreference");
  const classes = useStyles();

  const refreshTable = () => {
    setRefresh(!refresh);
  }

  //Ok but should not be able to change group at this level
  let prevIdGroup = ["0"];
  let prevRefresh = true;
  useEffect(() => {
    if (energychoice === 'choice')
      return;
    if (chartIdGroup && chartIdGroup[0] !== "0") {
      if ((prevIdGroup && prevIdGroup === chartIdGroup)
        && (prevRefresh && prevRefresh === refresh)) {
        return;
      }
      setLoading(true);
      let tmpfilters = filters.filter((filter) => filter.check);
      async function fetchData() {
        const response = await axios.get(
          getBillsQuery(chartIdGroup, displaymethod, energychoice, pageSize, page, sorted, dbValue, tmpfilters),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );
        setResults(response.data.bills);
        setTotalRows(response.data.meta.count);
        setLoading(false);
      }
      prevRefresh = refresh;
      prevIdGroup = chartIdGroup;
      fetchData();
    }
  }, [chartIdGroup, refresh, energychoice, dbValue, page, pageSize, sorted, displaymethod]);

  const handlePerRowsChange = (pageSize, page) => {
    setPageSize(pageSize);
    setPage(page);
    console.log('pagesize', page, pageSize);
  };
  const handlePageChange = (page) => {
    setPage(page);
  };
  const handleSort = (column, sortDirection) => {
    //console.log("column",column);
    let sortObject = {
      name: column.key,
      sort: sortDirection
    };
    setSorted(sortObject);
  };

  const request = debounce((value) => {
    setDbValue(value);
  }, 350);

  const debouceRequest = useCallback((value) => request(value), []);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const removeFilter = (id) => {
    let indexToRemove = filters.findIndex((filter) =>
      filter.id === id
    )
    let newFilters = [...filters];
    newFilters.splice(indexToRemove, 1);
    setFilters(newFilters);
  }

  const addFilter = () => {
    let newFilters = [...filters];
    let newfilterobj = {
      id: uuid(),
    };
    newFilters.push(newfilterobj);
    setFilters(newFilters);
  }

  const handleFilterChange = () => {
    setFilters([...filters]);
  }

  const handleDisplaymethodChange = (event) => { setDisplaymethod(event.target.value); };

  const FilterComponent = () => (
    <>
      <div style={{ marginTop: "-7px" }}>
        <UploadButton type="button" onClick={addFilter}>
          <Button
            type="button" round
            color="transparent"
            justIcon size={"sm"}
            onClick={addFilter}
          >
            <AddCircleOutline> </AddCircleOutline>
          </Button>
          Ajouter un filtre
        </UploadButton>
      </div>
      {
        filters.map((filter) => {
          return (
            <LineFilter filter={filter} handleFilterChange={handleFilterChange} removeFilter={removeFilter} refreshTable={refreshTable} />
          )
        })
      }
    </>
  );

  const reduceFunction = (data) => {
    //REDUCE HERE
    const groupeditemsobj = {};
    if (displaymethod === 'docreference') {
      data.map((item) => {
        const uniqueness = item.sender + "_" + item.energy + "_" + item.docreference;
        // const pdlbilluniqueness = item.sender + "_" + item.energy + "_" + item.docreference + "_" + item.pdl;
        let groupedbill = {};
        let ttc = item.ttc;
        let conso = item.conso;
        let begin = item.begin;
        let end = item.end;
        let pdlBills = [];
        item.rawdata.map((itemdata) => {
          if (moment(itemdata.begindate).isBefore(moment(begin)))
            begin = itemdata.begindate;
          if (moment(itemdata.enddate).isAfter(moment(end)))
            end = itemdata.enddate;
        });
        if (groupeditemsobj[uniqueness]) {
          let tmpgroupebill = groupeditemsobj[uniqueness];
          ttc = ttc + tmpgroupebill.ttc;
          conso = conso + tmpgroupebill.conso;
          if (tmpgroupebill.begin && moment(tmpgroupebill.begin).isValid() && begin && moment(begin).isValid() && moment(tmpgroupebill.begin).isBefore(begin)) {
            begin = tmpgroupebill.begin;
          }
          if (tmpgroupebill.end && moment(tmpgroupebill.end).isValid() && end && moment(end).isValid() && moment(tmpgroupebill.end).isAfter(end)) {
            end = tmpgroupebill.end;
          }
          pdlBills = tmpgroupebill.pdlBills;
        }
        pdlBills.push(item);

        groupedbill.ttc = ttc;
        groupedbill.conso = conso;
        groupedbill.sender = item.sender;
        groupedbill.pdlBills = pdlBills;
        groupedbill.count = pdlBills.length;
        groupedbill.billdate = item.billdate;
        groupedbill.docreference = item.docreference;
        groupedbill.end = end;
        groupedbill.id = uniqueness;
        groupedbill.source = item.source;
        groupedbill.begin = begin;
        groupedbill.energy = item.energy;
        if (item.billcanceled == 1)
          groupedbill.billcanceled = item.billcanceled;
        groupeditemsobj[uniqueness] = groupedbill;
      });
    }
    else if (displaymethod === 'pdl') {
      data.map((item) => {
        const uniqueness = item.sender + "_" + item.energy + "_" + item.pdl;
        let groupedbill = {};
        let ttc = item.ttc;
        let conso = item.conso;
        let begin = item.begin;
        let end = item.end;
        let pdlBills = [];
        item.rawdata.map((itemdata) => {
          if (moment(itemdata.begindate).isBefore(moment(begin)))
            begin = itemdata.begindate;
          if (moment(itemdata.enddate).isAfter(moment(end)))
            end = itemdata.enddate;
        });
        if (groupeditemsobj[uniqueness]) {
          let tmpgroupebill = groupeditemsobj[uniqueness];
          ttc = ttc + tmpgroupebill.ttc;
          conso = conso + tmpgroupebill.conso;
          if (tmpgroupebill.begin && moment(tmpgroupebill.begin).isValid() && begin && moment(begin).isValid() && moment(tmpgroupebill.begin).isBefore(begin)) {
            begin = tmpgroupebill.begin;
          }
          if (tmpgroupebill.end && moment(tmpgroupebill.end).isValid() && end && moment(end).isValid() && moment(tmpgroupebill.end).isAfter(end)) {
            end = tmpgroupebill.end;
          }
          pdlBills = tmpgroupebill.pdlBills;
        }
        pdlBills.push(item);
        groupedbill.ttc = ttc;
        groupedbill.conso = conso;
        groupedbill.sender = item.sender;
        groupedbill.pdlBills = pdlBills;
        groupedbill.count = pdlBills.length;
        groupedbill.billdate = item.billdate;
        groupedbill.pdl = item.pdl;
        groupedbill.end = end;
        groupedbill.id = uniqueness;
        groupedbill.source = item.source;
        groupedbill.begin = begin;

        groupedbill.energy = item.energy;
        if (item.billcanceled == 1)
          groupedbill.billcanceled = item.billcanceled;
        groupeditemsobj[uniqueness] = groupedbill;
      });
    }
    let groupedarray = [];
    for (var i in groupeditemsobj)
      groupedarray.push(groupeditemsobj[i]);

    return groupedarray;
  }

  const handleEnergychoiceChange = (event) => { setEnergychoice(event.target.value); };

  const handleClick = (event) => {
    setOpenMenu(event.currentTarget);
  };
  const handleClose = () => {
    setOpenMenu(null);
  };

  const handleCloseLoading = () => {
    setOpenloading(false);
  };
  //OK
  const headerComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };
    const onFilterText = (e) => {
      const { value: nextValue } = e.target;
      setFilterText(nextValue);
      const newValue = nextValue;
      debouceRequest(newValue);
    };

    let exportfullarray = [];
    selectedBills.forEach((item) => {
      const datadisplay = item.pdlBills.map((line) => {
        let datapdl = { ...line };
        datapdl.energy = item.energy;
        if (datapdl.rawdata) {
          datapdl.rawdata.map((linedata) => {
            if (linedata.value) {
              if (datapdl[linedata.key])
                datapdl[linedata.key] += Number(("" + linedata.value).replace(",", "."));
              else
                datapdl[linedata.key] = Number(("" + linedata.value).replace(",", "."));
            }
            if (moment(linedata.begindate).isBefore(moment(datapdl.begin)))
              datapdl.begin = linedata.begindate;
            if (moment(linedata.enddate).isAfter(moment(datapdl.end)))
              datapdl.end = linedata.enddate;
          });
        }
        return datapdl;
      });
      datadisplay.forEach((bill) => {
        let billtoexport = {};
        billtoexport[billtext.pdl] = bill.pdl;
        billtoexport[billtext.energy] = energyData.find((x) => x.id == item.energy)?.name;
        billtoexport[billtext.sender] = item.sender;
        billtoexport[billtext.docreference] = bill.docreference;
        billtoexport[billtext.billdate] = (bill.billdate && moment(bill.billdate).isValid()) ? moment(bill.billdate).format("DD/MM/YYYY") : "";
        billtoexport[billtext.begindate] = (bill.begin && moment(bill.begin).isValid()) ? moment(bill.begin).format("DD/MM/YYYY") : "";
        billtoexport[billtext.enddate] = (bill.end && moment(bill.end).isValid()) ? moment(bill.end).format("DD/MM/YYYY") : "";
        billtoexport[billtext.billstate] = (bill.billcanceled && bill.billcanceled == 1) ? billcanceled.find((x) => x.id == 'canceled')?.name : billcanceled.find((x) => x.id == 'validated')?.name;
        displayBillsColumnsData[item.energy].map((column) => {
          //billtoexport[column.name] = bill[column.id] ? new Intl.NumberFormat('fr-FR').format(bill[column.id]) : '';
          billtoexport[column.name] = bill[column.id] ? ('' + bill[column.id]).replace('.', ',').replace(' ', '') : '';
        });
        exportfullarray.push(billtoexport);
      });
    });

    const exportAll = (detailed) => {
      setOpenloading(true);
      let tmpfilters = filters.filter((filter) => filter.check);
      axios
        .get(
          getBillsQuery(chartIdGroup, displaymethod, energychoice, totalRows, 1, sorted, dbValue, tmpfilters),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            let allresults = reduceFunction(res.data.bills);
            if (detailed) {
              let allexportfullarray = [];
              allresults.forEach((item) => {
                const datadisplay = item.pdlBills.map((line) => {
                  let datapdl = { ...line };
                  datapdl.energy = item.energy;
                  if (datapdl.rawdata) {
                    datapdl.rawdata.map((linedata) => {
                      if (linedata.value) {
                        if (datapdl[linedata.key])
                          datapdl[linedata.key] += Number(("" + linedata.value).replace(",", "."));
                        else
                          datapdl[linedata.key] = Number(("" + linedata.value).replace(",", "."));
                      }
                      if (moment(linedata.begindate).isBefore(moment(datapdl.begin)))
                        datapdl.begin = linedata.begindate;
                      if (moment(linedata.enddate).isAfter(moment(datapdl.end)))
                        datapdl.end = linedata.enddate;
                    });
                  }
                  return datapdl;
                });
                datadisplay.forEach((bill) => {
                  let billtoexport = {};
                  billtoexport[billtext.pdl] = bill.pdl;
                  billtoexport[billtext.energy] = energyData.find((x) => x.id == item.energy)?.name;
                  billtoexport[billtext.sender] = item.sender;
                  billtoexport[billtext.docreference] = bill.docreference;
                  billtoexport[billtext.billdate] = (bill.billdate && moment(bill.billdate).isValid()) ? moment(bill.billdate).format("DD/MM/YYYY") : "";
                  billtoexport[billtext.begindate] = (bill.begin && moment(bill.begin).isValid()) ? moment(bill.begin).format("DD/MM/YYYY") : "";
                  billtoexport[billtext.enddate] = (bill.end && moment(bill.end).isValid()) ? moment(bill.end).format("DD/MM/YYYY") : "";
                  billtoexport[billtext.billstate] = (bill.billcanceled && bill.billcanceled == 1) ? billcanceled.find((x) => x.id == 'canceled')?.name : billcanceled.find((x) => x.id == 'validated')?.name;
                  displayBillsColumnsData[item.energy].map((column) => {
                    //billtoexport[column.name] = bill[column.id] ? new Intl.NumberFormat('fr-FR').format(bill[column.id]) : '';
                    billtoexport[column.name] = bill[column.id] ? ('' + bill[column.id]).replace('.', ',').replace(' ', '') : '';
                  });
                  allexportfullarray.push(billtoexport);
                });
              });
              downloadCSV(allexportfullarray);
              handleCloseLoading();
            }
            else {
              let allexportarray = allresults.map((item) => {
                let billtoexport = {};
                if (displaymethod === 'docreference') {
                  billtoexport[billtext.energy] = energyData.find((x) => x.id == item.energy)?.name;
                  billtoexport[billtext.sender] = item.sender;
                  billtoexport[billtext.source] = sources.find((x) => x.id == item.source)?.name;
                  billtoexport[billtext.docreference] = item.docreference;
                  billtoexport[billtext.billdate] = (item.billdate && moment(item.billdate).isValid()) ? moment(item.billdate).format("DD/MM/YYYY") : "";
                  billtoexport[billtext.begindate] = (item.begin && moment(item.begin).isValid()) ? moment(item.begin).format("DD/MM/YYYY") : "";
                  billtoexport[billtext.enddate] = (item.end && moment(item.end).isValid()) ? moment(item.end).format("DD/MM/YYYY") : "";
                  billtoexport[billtext.conso] = item.conso && new Intl.NumberFormat('fr-FR', { useGrouping: false }).format(item.conso);
                  billtoexport[billtext.unit] = consoUnitData.find((x) => x.id == item.energy)?.name;
                  billtoexport[billtext.ttc] = item.ttc && new Intl.NumberFormat('fr-FR', { useGrouping: false, maximumFractionDigits: 2 }).format(item.ttc);
                  billtoexport[billtext.pdlcount] = item.pdlBills.length;
                }
                else if (displaymethod === 'pdl') {
                  billtoexport[billtext.pdl] = item.pdl;
                  billtoexport[billtext.energy] = energyData.find((x) => x.id == item.energy)?.name;
                  billtoexport[billtext.sender] = item.sender;
                  billtoexport[billtext.source] = sources.find((x) => x.id == item.source)?.name;
                  billtoexport[billtext.begindate] = (item.begin && moment(item.begin).isValid()) ? moment(item.begin).format("DD/MM/YYYY") : "";
                  billtoexport[billtext.enddate] = (item.end && moment(item.end).isValid()) ? moment(item.end).format("DD/MM/YYYY") : "";
                  billtoexport[billtext.conso] = item.conso && new Intl.NumberFormat('fr-FR', { useGrouping: false }).format(item.conso);
                  billtoexport[billtext.unit] = consoUnitData.find((x) => x.id == item.energy)?.name;
                  billtoexport[billtext.ttc] = item.ttc && new Intl.NumberFormat('fr-FR', { useGrouping: false, maximumFractionDigits: 2 }).format(item.ttc);
                  billtoexport[billtext.billcount] = item.pdlBills.length;
                }
                return billtoexport;
              });
              downloadCSV(allexportarray);
              handleCloseLoading();
            }
          }
          else {
            handleCloseLoading();
          }
        })
        .catch((error) => {
          handleCloseLoading();
        });
    }


    let exportarray = selectedBills.map((item) => {

      let billtoexport = {};
      if (displaymethod === 'docreference') {
        billtoexport[billtext.energy] = energyData.find((x) => x.id == item.energy)?.name;
        billtoexport[billtext.sender] = item.sender;
        billtoexport[billtext.source] = sources.find((x) => x.id == item.source)?.name;
        billtoexport[billtext.docreference] = item.docreference;
        billtoexport[billtext.billdate] = (item.billdate && moment(item.billdate).isValid()) ? moment(item.billdate).format("DD/MM/YYYY") : "";
        billtoexport[billtext.begindate] = (item.begin && moment(item.begin).isValid()) ? moment(item.begin).format("DD/MM/YYYY") : "";
        billtoexport[billtext.enddate] = (item.end && moment(item.end).isValid()) ? moment(item.end).format("DD/MM/YYYY") : "";
        billtoexport[billtext.conso] = item.conso && new Intl.NumberFormat('fr-FR', { useGrouping: false }).format(item.conso);
        billtoexport[billtext.unit] = consoUnitData.find((x) => x.id == item.energy)?.name;
        billtoexport[billtext.ttc] = item.ttc && new Intl.NumberFormat('fr-FR', { useGrouping: false, maximumFractionDigits: 2 }).format(item.ttc);
        billtoexport[billtext.pdlcount] = item.pdlBills.length;
      }
      else if (displaymethod === 'pdl') {
        billtoexport[billtext.pdl] = item.pdl;
        billtoexport[billtext.energy] = energyData.find((x) => x.id == item.energy)?.name;
        billtoexport[billtext.sender] = item.sender;
        billtoexport[billtext.source] = sources.find((x) => x.id == item.source)?.name;
        billtoexport[billtext.begindate] = (item.begin && moment(item.begin).isValid()) ? moment(item.begin).format("DD/MM/YYYY") : "";
        billtoexport[billtext.enddate] = (item.end && moment(item.end).isValid()) ? moment(item.end).format("DD/MM/YYYY") : "";
        billtoexport[billtext.conso] = item.conso && new Intl.NumberFormat('fr-FR', { useGrouping: false }).format(item.conso);
        billtoexport[billtext.unit] = consoUnitData.find((x) => x.id == item.energy)?.name;
        billtoexport[billtext.ttc] = item.ttc && new Intl.NumberFormat('fr-FR', { useGrouping: false, maximumFractionDigits: 2 }).format(item.ttc);
        billtoexport[billtext.billcount] = item.pdlBills.length;
      }
      return billtoexport;
    });
    return (
      <>
        <FilterDiv>
          <CustomSelect
            inputTitle={billpagetext.energychoice}
            selectValue={energychoice}
            handleSelectValueChange={handleEnergychoiceChange}
            data={energyData}
          />
          <CustomSelect
            inputTitle={billpagetext.displaymethod}
            selectValue={displaymethod}
            handleSelectValueChange={handleDisplaymethodChange}
            data={displaymethodData}
          />
        </FilterDiv>
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {/* <UploadButton type="button" onClick={handleClear}>
          <ExportTableToCSV dataarray={exportarray} disabled={!selectedBills || selectedBills.length < 1} />
        </UploadButton>
         */}
        <Tooltip title="Exporter en CSV">
          <UploadButton type="button" onClick={handleClear}>
            <Button
              onClick={handleClick}
              color={"info"}
              className={classes.actionButton}
              disabled={!results || results.length < 1}
            >
              <GetAppIcon fontSize="large" />
            </Button>
          </UploadButton>
        </Tooltip>

        <Menu
          id="chart-menu"
          className={"chart-menu"}
          anchorEl={openMenu}
          keepMounted
          aria-haspopup={'menu'}
          open={Boolean(openMenu)}
          onClose={handleClose}
        >
          <MenuItem
            onClick={() => {
              exportAll(false);
              handleClose();
            }}
            key={`handlegroup`}>
            Exporter toutes les factures groupées
          </MenuItem>
          <MenuItem
            onClick={() => {
              exportAll(true);
              handleClose();
            }}
            key={`handlegroup`}>
            Exporter toutes les factures détaillées
          </MenuItem>
          <MenuItem
            disabled={!selectedBills || selectedBills.length < 1}
            onClick={() => {
              downloadCSV(exportarray);
              handleClose();
            }}
            key={`handlegroup`}>
            Exporter les factures groupées sélectionnées
          </MenuItem>
          <MenuItem
            disabled={!selectedBills || selectedBills.length < 1}
            onClick={() => downloadCSV(exportfullarray)}
            key={`handledetail`}>
            Exporter les factures détaillées sélectionnées
          </MenuItem>
        </Menu>
        <Dialog
          onClose={handleCloseLoading}
          aria-labelledby="edituser-dialog-title"
          fullWidth="true"
          maxWidth="sm"
          open={openloading}
        >
          <DialogContent dividers>
            <LoadingText>Création de l'export en cours</LoadingText>
            <div style={{ height: 20, marginTop: 10 }}><LinearProgress /></div>
          </DialogContent>
        </Dialog>
      </>
    );
  }, [filterText, resetPaginationToggle, selectedBills, displaymethod, energychoice, openMenu, openloading, results]);

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <>
        <FilterComponent />
      </>
    );
  }, [filters]);

  return {
    gridState: {
      noContextMenu: true,
      defaultPageSize: 10,
      data: reduceFunction(results),
      paginationTotalRows: totalRows,
      onChangeRowsPerPage: handlePerRowsChange,
      onChangePage: handlePageChange,
      onSort: handleSort,
      filterable: true,
      manual: true,
      // paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      //  subHeaderAlign: "left",
      actions: headerComponentMemo,
      loading,
    },
    refetch: refreshTable,
    setSelectedBills,
    displaymethod
  };
}
